import React from "react";
import FormElement, { FormElementProps } from "../forms/common/FormElement";
import SelectField, { SelectProps } from "../formx/Select";

type Props = SelectProps & FormElementProps;

export const Select: React.FC<Props> = (props) => {
  const { label, innerRef, ...rest } = props;
  return (
    <FormElement required={props.required} field={<SelectField {...props} />} {...rest} />
  );
};
